<template>
  <div class="header">
    <div class="header__left">
      <i class="el-icon-s-grid header__menu-icon"></i>
      <span class="header__brand">付无忧管理后台</span>
      <span class="header__sep">|</span>
      <span class="header__page-title">{{ currentRoute.meta ? currentRoute.meta.title : '' }}</span>
    </div>
    <div class="header__right">
      <el-popover
        placement="bottom-end"
        width="240"
        trigger="hover"
        popper-class="header-user-popover">
        <div class="user-pop">
          <div class="user-pop__top">
            <el-avatar size="medium" :src="avatar"></el-avatar>
            <div class="user-pop__info">
              <div class="user-pop__name">{{ $store.getters.userInfo.agentName }}</div>
              <div class="user-pop__id">ID：{{ $store.getters.userInfo.agentId }}</div>
            </div>
          </div>
          <div class="user-pop__out" @click="out">
            <i class="el-icon-switch-button"></i>
            <span>退出登录</span>
          </div>
        </div>
        <div slot="reference" class="header__user">
          <el-avatar size="small" :src="avatar"></el-avatar>
          <span class="header__user-name">{{ $store.getters.userInfo.agentName }}</span>
          <i class="el-icon-arrow-down header__user-arrow"></i>
        </div>
      </el-popover>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "Header",
  data() {
    return {
      currentRoute: {}
    }
  },
  computed: {
    avatar() {
      return "https://img0.baidu.com/it/u=2580450068,3312521163&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=500"
    }
  },
  watch: {
    $route(e) {
      this.currentRoute = this.$route
    }
  },
  mounted() {
    this.currentRoute = this.$route
  },
  methods: {
    ...mapMutations(["logout"]),
    out() {
      this.logout()
      location.reload()
    }
  }
}
</script>

<style scoped>
.header {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #121A2B;
}
.header__left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.header__menu-icon {
  font-size: 18px;
  color: #5A6C7D;
  cursor: pointer;
}
.header__brand {
  font-size: 15px;
  font-weight: 700;
  color: #121A2B;
}
.header__sep {
  color: #A0B5CC;
  font-size: 14px;
}
.header__page-title {
  font-size: 13px;
  color: #4A6C8D;
  font-weight: 500;
}
.header__right {
  display: flex;
  align-items: center;
}
.header__user {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 10px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;
}
.header__user:hover {
  background: rgba(0,0,0,0.04);
}
.header__user-name {
  font-size: 13px;
  color: #2C4A6B;
  font-weight: 500;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.header__user-arrow {
  font-size: 12px;
  color: #8AA5C0;
}
.user-pop__top {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 4px 14px;
  border-bottom: 1px solid #F2F3F5;
}
.user-pop__info {
  flex: 1;
  overflow: hidden;
}
.user-pop__name {
  font-size: 14px;
  font-weight: 600;
  color: #1D2129;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.user-pop__id {
  font-size: 12px;
  color: #86909C;
  margin-top: 3px;
}
.user-pop__out {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  padding: 10px 8px;
  border-radius: 8px;
  color: #F5483B;
  font-size: 13px;
  cursor: pointer;
  transition: background 0.2s;
}
.user-pop__out:hover {
  background: #FFF1F0;
}
</style>
